import React from "react";
import classes from "./Box.module.css";

const SmallBoxes = (props) => {
  return (
    <div className={classes.Box}>
      <h1>{props.Heading}</h1>
      <div className={classes.Group}>
        <div>{props.Tiles[0]}</div>
      </div>
      <div className={classes.Group}>
        <div>{props.Tiles[1]}</div>
        <div>{props.Tiles[2]}</div>
      </div>
      <div className={classes.Group}>
        <div>{props.Tiles[3]}</div>
      </div>
    </div>
  );
};

export default SmallBoxes;
